import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const B3LogoSquare = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g fill="none" fillRule="evenodd"><rect fill="#3368EF" height={24} rx={0} width={24} /><path d="M4.194 7.255h7.442a.24.24 0 0 1 .243.234v3.357c0 .209-.127.4-.324.486l-.938.414a.125.125 0 0 0-.075.113c0 .048.029.092.074.112l.946.433a.534.534 0 0 1 .317.484v3.625a.24.24 0 0 1-.243.235H4.194a.681.681 0 0 1-.694-.668V7.923c0-.37.31-.668.694-.668Zm4.036 6.328c.19 0 .325-.024.406-.073.087-.05.131-.14.131-.274v-.022c0-.14-.047-.239-.142-.295-.088-.056-.238-.084-.45-.084H6.788v.748H8.23Zm-.065-2.563c.336 0 .504-.116.504-.348v-.053c0-.133-.044-.225-.132-.274-.08-.056-.215-.084-.405-.084H6.788v.76h1.377Zm4.345 1.783h3.067c0 .24.044.404.131.496.095.091.23.137.406.137.3 0 .45-.165.45-.496 0-.162-.052-.278-.154-.348-.095-.07-.241-.106-.439-.106h-1.687v-1.223l2.597-.622h-4.37a.217.217 0 0 1-.222-.213V7.433c0-.098.083-.178.185-.178h7.19a.68.68 0 0 1 .694.668v2.393a.59.59 0 0 1-.467.569l-2.846.652.132.022h2.716c.335 0 .607.261.607.584v3.937a.68.68 0 0 1-.694.668h-7.332a.181.181 0 0 1-.185-.178v-3.554c0-.118.1-.213.221-.213Z" fill="#FFF" fillRule="nonzero" /></g>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== rest || $[9] !== t2) {
    t4 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = className;
    $[8] = rest;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const B3LogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0Zm11.636 7.255H4.194a.681.681 0 0 0-.694.668v8.157c0 .369.31.668.694.668h7.442a.24.24 0 0 0 .243-.235v-3.625a.534.534 0 0 0-.317-.484l-.946-.433a.124.124 0 0 1-.074-.112c0-.048.03-.092.075-.113l.938-.414a.535.535 0 0 0 .324-.486V7.489a.24.24 0 0 0-.243-.234Zm8.028 0h-7.19a.181.181 0 0 0-.185.178v2.995c0 .117.1.213.221.213h4.371l-2.597.622v1.223h1.687c.198 0 .344.036.439.106.102.07.153.186.153.348 0 .33-.15.496-.45.496-.175 0-.31-.046-.405-.137-.087-.092-.131-.257-.131-.496H12.51a.217.217 0 0 0-.22.213v3.554c0 .098.082.178.184.178h7.332a.68.68 0 0 0 .694-.668v-3.937a.596.596 0 0 0-.607-.584h-2.716l-.132-.022 2.846-.652a.59.59 0 0 0 .467-.569V7.923a.68.68 0 0 0-.694-.668Zm-11.489 5.58c.212 0 .362.028.45.084.095.056.142.155.142.295v.022c0 .133-.044.224-.131.274-.08.049-.216.073-.406.073H6.788v-.748Zm-.043-2.574c.19 0 .325.028.405.084.088.05.132.14.132.274v.053c0 .232-.168.348-.504.348H6.788v-.76Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};